<template>
    <div class="unpack-center">
        <h1><span >{{ detailData.title }}</span></h1>
        <div class="apart-list" v-html="detailData.content">

        </div>
    </div>
</template>
<script>
export default {
   props:{
    detailData:{
        type:Object,
        default(){
            return {
                title:'',
                content:''
            }
        }
    }
   }
}
</script>
<style lang="scss" scoped>
p,
h1,
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}
.unpack-center {
    width: 36.04vw;
    overflow: auto;
    padding: 8px 36px;
    // border: 1px solid greenyellow;
    font-family: Microsoft YaHei, Microsoft YaHei;
    display: flex;
    flex-direction: column;
    .apart-list {
        
        overflow: auto;
        flex: 1;
        font-weight: 400;
        font-size: 15px;
        color: #222222;
        line-height: 22px;
        white-space: pre-wrap; /* 保留换行和空格 */
        @include no_scrollbar();
    }
}

h1 {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
    color: #0A0A0A;
    width: 100%;
    position: relative;
}
</style>